import { atom } from 'jotai'

export const navigationIndexAtom = atom<number[]>([])
